var yousers = require('@yola/yousersjs');

function fetchUserProperties() {
  return yousers
    .preferences()
    .get();
}

module.exports = fetchUserProperties;